import echo from "./echo";
import { store } from "./redux/store";
import { getCookie } from "./services/cookies.service";
import { setAccount } from "./redux/slices/accountSlice";
import { setVerificationData } from "./redux/slices/verificationSlice";

export function registerPusherListeners() {
  const userCookie = getCookie("user");
  if (!userCookie) return;

  const userData = JSON.parse(userCookie);
  const userId = userData?.id;

  if (!userId) return;

  const balanceChannelName = `balance-updates-${userId}`;
  const balanceEventName = `.balance-updates-${userId}`;
  const channel = echo.channel(balanceChannelName);

  channel.listen(balanceEventName, (event) => {
    // console.log("💰 Balance updated event received:", event);
    store.dispatch(
      setAccount({
        balance: event.balance || 0,
        formatted_balance: event.formatted_balance || "0",
      }),
    );
  });

  const userChannel = echo.channel(`App.Models.User.${userId}`);
  userChannel.listen(
    ".Illuminate\\Notifications\\Events\\BroadcastNotificationCreated",
    (event) => {
      console.log("event in push", event);
      if (!event) return;
      store.dispatch(setVerificationData(event));
    },
  );
}
